import { Component, Inject, OnDestroy } from '@angular/core';
import { CoreSeoPages } from '@app/store/enums/core-seo-pages';
import { IAppConfig } from '@app/store/models/config.interface';
import { OrganizationQRLogo } from '@app/store/models/organization-qr-logo.interface';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { Subscription } from 'rxjs';
import { APP_CONFIG } from '../../config/config';
import { CoreService } from '../../services/core.service';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-core-api-documentation',
  templateUrl: './core-api-documentation.component.html',
  styleUrls: ['./core-api-documentation.component.scss']
})
export class CoreApiDocumentationComponent implements OnDestroy {

  request_param_example_1 = {
    text: "brandqrcodes.com",
    logo: "default",
    save: false,
    margin: 1.5,
    dot_color: "#EF5454",
    background_color: "#FBD3D4"
  }

  session_info: SessionInfo
  private subscriptions: Subscription[] = []

  constructor(
    public seoService: SeoService,
    public coreService: CoreService,
    @Inject(APP_CONFIG) public readonly config: IAppConfig
  ) {
    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => {
      this.session_info = si;
    }))
    this.seoService.generateMetaTags(CoreSeoPages.API_DOCUMENTATION)
  }

  ngOnDestroy(): void {
    this.subscriptions.map(sub => sub.unsubscribe())
  }

  getDefaultLogo(): OrganizationQRLogo {
    return this.coreService.isLoggedIn() ? this.session_info.user_details.current_organization_details.current_team_details.qr_settings.logos.find(logo => this.session_info.user_details.current_organization_details.current_team_details.qr_settings.default === logo.id) : null
  }

}
